import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form-latest';
import { DateRenderer } from '@/components/UI/DateRenderers/DateRenderers';

const Datepicker: FC<{ name: string }> = ({ name }) => {
  const { control } = useFormContext();
  return <Controller name={name} control={control} render={({ field: { value } }) => <DateRenderer value={value} />} />;
};

export default Datepicker;
